export enum MessagingCampaignTabs {
  Configure = 'configure',
  Target = 'target',
  Schedule = 'schedule',
}

export const UPDATED_SUCCESS_MESSAGE = 'Your changes have been successfully saved';
